import { render, staticRenderFns } from "./LateFees.vue?vue&type=template&id=32b8c68c"
import script from "./LateFees.vue?vue&type=script&lang=js"
export * from "./LateFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports